import { SELECTOR_ROOT } from './const';
import { PoemBlock } from './controller';

// Standalone bootstrap (rule #18): loaded only by the poem block itself
// (templates/cards/music/poem-block.html.twig), so no other page pays for it.

let block: PoemBlock | null = null;

const root = document.querySelector<HTMLElement>(SELECTOR_ROOT);
if (root) {
    block = new PoemBlock(root);
    block.mount();
}

/**
 * The `card-created` cut (cardCreator.js): how the card's poem came about –
 * `generated`, `edited` or written by hand (`manual`). Undefined without a poem,
 * so the goal goes as it always did.
 */
export function cardCreatedGoalParams(): Maybe<Record<string, string>> {
    const origin = block?.origin();

    return origin ? { aiPoem: origin } : undefined;
}
